<template>
  <el-container ref="documentViewer" style="height: 700px; border: 1px solid #eee">
    <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
      <el-menu :default-openeds="['1']">
        <el-submenu index="1">
          <template slot="title"><i class="el-icon-tickets"></i>{{ $t('invoice.selectedInvoices') }}</template>
          <el-menu-item-group>
            <el-menu-item v-for="pdf in pdfs" :key="pdf.invoiceID" @click="selectFile(pdf)">{{
              pdf.invoiceNumber
            }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-container>
      <el-main>
        <iframe width="100%" height="100%" :src="fullSizePdf"></iframe>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'DocumentViewerDialog',
  props: {
    pdfs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedFile: null
    };
  },
  computed: {
    fullSizePdf() {
      let file = this.selectedFile;
      if (!file) {
        file = this.pdfs.length && this.pdfs[0];
      }
      return file && this.createObjectURL(file);
    }
  },
  watch: {
    pdfs() {
      this.selectedFile = null;
    }
  },
  methods: {
    createObjectURL(pdf) {
      const file = this.b64toFile(pdf.content, pdf.fileName, pdf.mediaType);
      return URL.createObjectURL(file);
    },
    b64toFile(b64Data, fileName, mediaType, sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      return new File(byteArrays, fileName, { type: mediaType });
    },
    selectFile(pdf) {
      this.selectedFile = pdf;
    }
  }
};
</script>
